// extracted by mini-css-extract-plugin
export default {"security-main-details":"security-details_security-main-details__CHgrv","section":"security-details_section__oNACG","line":"security-details_line__0KDAL"};